import {
  evalAll3oat76nn6xi8b as evalAll,
  firstError1efmomhi1a6qo as firstError,
  ExcelFunction2k41pwq8xg6wo as ExcelFunction,
} from './ExcelExpr.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Empty2w0k1znsc32mg as Empty,
  asNumber3rgwwt2ok3oo4 as asNumber,
  Error21zp7h9320rwp as Error_0,
  Number6kmrfn4klz39 as Number_0,
  asBool20p924j1rdl68 as asBool,
  Bool1r3p37fvso3wz as Bool,
  compareValues1f9uh3diuktj1 as compareValues,
  Text2b8ye3kmips1o as Text,
  asTextufk6946h4qqq as asText,
} from './ExcelValue.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  drop3na99dw9feawf as drop,
  last1vo29oleiqj36 as last,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_builtinFunctions() {
  _init_properties_ExcelFunctions_kt__22brwc();
  return builtinFunctions;
}
var builtinFunctions;
function numericArgs(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var vals = evalAll(args, ctx);
  if (firstError(vals) == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return null;
  }
  var nums = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(vals.get_size_woubt6_k$());
  var _iterator__ex2g4s = vals.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var v = _iterator__ex2g4s.next_20eer_k$();
    if (v instanceof Empty())
      continue $l$loop;
    var n = asNumber(v);
    if (n instanceof Error_0())
      return null;
    nums.add_utx5q5_k$(n instanceof Number_0() ? n : THROW_CCE());
  }
  return nums;
}
function oneNumber(args, ctx, fn) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (!(args.get_size_woubt6_k$() === 1))
    return new (Error_0())('VALUE', 'Function requires exactly 1 numeric argument');
  var n = args.get_c1px32_k$(0).eval_4bdj8k_k$(ctx);
  var num = asNumber(n);
  if (num instanceof Error_0())
    return num;
  var result = fn((num instanceof Number_0() ? num : THROW_CCE()).value_1);
  return engineNumber(result);
}
function roundFns(args, ctx, mode) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'ROUND family requires numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.isEmpty_y1axqb_k$())
    return new (Error_0())('VALUE', 'ROUND family requires a number');
  var x = nums.get_c1px32_k$(0).value_1;
  var digits = nums.get_size_woubt6_k$() > 1 ? numberToInt(nums.get_c1px32_k$(1).value_1) : 0;
  // Inline function 'kotlin.math.pow' call
  var factor = Math.pow(10.0, digits);
  var scaled = x * factor;
  var tmp_0;
  switch (mode.ordinal_1) {
    case 0:
      // Inline function 'kotlin.math.abs' call

      // Inline function 'kotlin.math.floor' call

      var x_0 = Math.abs(scaled) + 0.5;
      tmp_0 = Math.floor(x_0) * signOf(x);
      break;
    case 1:
      // Inline function 'kotlin.math.abs' call

      // Inline function 'kotlin.math.ceil' call

      var x_1 = Math.abs(scaled);
      tmp_0 = Math.ceil(x_1) * signOf(x);
      break;
    case 2:
      // Inline function 'kotlin.math.abs' call

      // Inline function 'kotlin.math.floor' call

      var x_2 = Math.abs(scaled);
      tmp_0 = Math.floor(x_2) * signOf(x);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var result = tmp_0;
  return engineNumber(result / factor);
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  RoundMode_NEAREST_instance = new (RoundMode())('NEAREST', 0);
  RoundMode_UP_instance = new (RoundMode())('UP', 1);
  RoundMode_DOWN_instance = new (RoundMode())('DOWN', 2);
}
var RoundMode_NEAREST_instance;
var RoundMode_UP_instance;
var RoundMode_DOWN_instance;
var RoundModeClass;
function RoundMode() {
  if (RoundModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'RoundMode');
    RoundModeClass = $;
  }
  return RoundModeClass;
}
function floorCeil(args, ctx, up) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'FLOOR/CEILING requires numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.isEmpty_y1axqb_k$())
    return new (Error_0())('VALUE', 'FLOOR/CEILING requires a number');
  var x = nums.get_c1px32_k$(0).value_1;
  var sig = nums.get_size_woubt6_k$() > 1 ? nums.get_c1px32_k$(1).value_1 : 1.0;
  if (sig === 0.0)
    return new (Error_0())('DIV/0', 'Significance cannot be zero');
  var tmp_0;
  if (up) {
    // Inline function 'kotlin.math.ceil' call
    var x_0 = x / sig;
    tmp_0 = Math.ceil(x_0);
  } else {
    // Inline function 'kotlin.math.floor' call
    var x_1 = x / sig;
    tmp_0 = Math.floor(x_1);
  }
  var rounded = tmp_0;
  return engineNumber(rounded * sig);
}
function engineNumber(d) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (isNaN_0(d))
    return new (Error_0())('NUM', 'Result is not a number');
  if (isInfinite(d))
    return new (Error_0())('NUM', 'Result is too large');
  return new (Number_0())(d);
}
function signOf(d) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return d < 0 ? -1.0 : 1.0;
}
var sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0Class;
function sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0() {
  if (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      invoke_pr27w4_k$(args, ctx) {
        return this.function_1(args, ctx);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, ExcelFunction()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0', VOID, VOID, [ExcelFunction(), FunctionAdapter()]);
    sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0Class = $;
  }
  return sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0Class;
}
function builtinFunctions$register($this_buildMap, name, fn) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = name.toUpperCase();
  $this_buildMap.put_4fpzoq_k$(tmp$ret$0, fn);
}
function builtinFunctions$lambda(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (args.get_size_woubt6_k$() < 3)
    return new (Error_0())('VALUE', 'IF requires 3 arguments');
  var cond = asBool(args.get_c1px32_k$(0).eval_4bdj8k_k$(ctx));
  if (cond instanceof Error_0())
    return cond;
  var tmp;
  if ((cond instanceof Bool() ? cond : THROW_CCE()).value_1) {
    tmp = args.get_c1px32_k$(1).eval_4bdj8k_k$(ctx);
  } else {
    tmp = args.get_c1px32_k$(2).eval_4bdj8k_k$(ctx);
  }
  return tmp;
}
function builtinFunctions$lambda_0(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var vals = evalAll(args, ctx);
  var tmp0_safe_receiver = firstError(vals);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var result = true;
  var _iterator__ex2g4s = vals.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var v = _iterator__ex2g4s.next_20eer_k$();
    var b = asBool(v);
    if (b instanceof Error_0())
      return b;
    var tmp;
    if (b instanceof Bool()) {
      tmp = !b.value_1;
    } else {
      tmp = false;
    }
    if (tmp)
      result = false;
  }
  return new (Bool())(result);
}
function builtinFunctions$lambda_1(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var vals = evalAll(args, ctx);
  var tmp0_safe_receiver = firstError(vals);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var result = false;
  var _iterator__ex2g4s = vals.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var v = _iterator__ex2g4s.next_20eer_k$();
    var b = asBool(v);
    if (b instanceof Error_0())
      return b;
    var tmp;
    if (b instanceof Bool()) {
      tmp = b.value_1;
    } else {
      tmp = false;
    }
    if (tmp)
      result = true;
  }
  return new (Bool())(result);
}
function builtinFunctions$lambda_2(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (args.isEmpty_y1axqb_k$())
    return new (Error_0())('VALUE', 'NOT requires 1 argument');
  var b = asBool(args.get_c1px32_k$(0).eval_4bdj8k_k$(ctx));
  var tmp;
  if (b instanceof Error_0()) {
    tmp = b;
  } else {
    tmp = new (Bool())(!(b instanceof Bool() ? b : THROW_CCE()).value_1);
  }
  return tmp;
}
function builtinFunctions$lambda_3(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return new (Bool())(true);
}
function builtinFunctions$lambda_4(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return new (Bool())(false);
}
function builtinFunctions$lambda_5(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (args.get_size_woubt6_k$() < 3)
    return new (Error_0())('VALUE', 'SWITCH requires at least 3 arguments');
  var target = args.get_c1px32_k$(0).eval_4bdj8k_k$(ctx);
  if (target instanceof Error_0())
    return target;
  var rest = drop(args, 1);
  var pairCount = rest.get_size_woubt6_k$() / 2 | 0;
  var inductionVariable = 0;
  if (inductionVariable < pairCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var value = rest.get_c1px32_k$(imul(i, 2)).eval_4bdj8k_k$(ctx);
      if (value instanceof Error_0())
        return value;
      var _destruct__k2r9zo = compareValues(target, value);
      var cmp = _destruct__k2r9zo.component1_7eebsc_k$();
      var err = _destruct__k2r9zo.component2_7eebsb_k$();
      if (!(err == null))
        return err;
      if (cmp === 0)
        return rest.get_c1px32_k$(imul(i, 2) + 1 | 0).eval_4bdj8k_k$(ctx);
    }
     while (inductionVariable < pairCount);
  return (rest.get_size_woubt6_k$() % 2 | 0) === 1 ? last(rest).eval_4bdj8k_k$(ctx) : new (Error_0())('N/A', 'No default value in SWITCH');
}
function builtinFunctions$lambda_6(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'SUM requires numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = nums.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp_0 = sum;
    sum = tmp_0 + element.value_1;
  }
  var tmp$ret$0 = sum;
  return new (Number_0())(tmp$ret$0);
}
function builtinFunctions$lambda_7(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'MAX requires numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.isEmpty_y1axqb_k$())
    return new (Error_0())('VALUE', 'MAX requires at least one argument');
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = nums.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var maxValue = iterator.next_20eer_k$().value_1;
  while (iterator.hasNext_bitz1p_k$()) {
    var v = iterator.next_20eer_k$().value_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = maxValue;
    maxValue = Math.max(a, v);
  }
  var tmp$ret$0 = maxValue;
  return new (Number_0())(tmp$ret$0);
}
function builtinFunctions$lambda_8(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'MIN requires numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.isEmpty_y1axqb_k$())
    return new (Error_0())('VALUE', 'MIN requires at least one argument');
  // Inline function 'kotlin.collections.minOf' call
  var iterator = nums.iterator_jk1svi_k$();
  if (!iterator.hasNext_bitz1p_k$())
    throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
  var minValue = iterator.next_20eer_k$().value_1;
  while (iterator.hasNext_bitz1p_k$()) {
    var v = iterator.next_20eer_k$().value_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var tmp$ret$0 = minValue;
  return new (Number_0())(tmp$ret$0);
}
function builtinFunctions$lambda_9(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return oneNumber(args, ctx, builtinFunctions$lambda$lambda);
}
function builtinFunctions$lambda$lambda(it) {
  _init_properties_ExcelFunctions_kt__22brwc();
  // Inline function 'kotlin.math.abs' call
  return Math.abs(it);
}
function builtinFunctions$lambda_10(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return roundFns(args, ctx, RoundMode_NEAREST_getInstance());
}
function builtinFunctions$lambda_11(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return roundFns(args, ctx, RoundMode_UP_getInstance());
}
function builtinFunctions$lambda_12(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return roundFns(args, ctx, RoundMode_DOWN_getInstance());
}
function builtinFunctions$lambda_13(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return floorCeil(args, ctx, false);
}
function builtinFunctions$lambda_14(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return floorCeil(args, ctx, true);
}
function builtinFunctions$lambda_15(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return oneNumber(args, ctx, builtinFunctions$lambda$lambda_0);
}
function builtinFunctions$lambda$lambda_0(it) {
  _init_properties_ExcelFunctions_kt__22brwc();
  // Inline function 'kotlin.math.floor' call
  return Math.floor(it);
}
function builtinFunctions$lambda_16(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'MOD requires 2 numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.get_size_woubt6_k$() < 2)
    return new (Error_0())('VALUE', 'MOD requires 2 arguments');
  var divisor = nums.get_c1px32_k$(1).value_1;
  if (divisor === 0.0)
    return new (Error_0())('DIV/0', 'Division by zero');
  var tmp_0 = nums.get_c1px32_k$(0).value_1;
  // Inline function 'kotlin.math.floor' call
  var x = nums.get_c1px32_k$(0).value_1 / divisor;
  var result = tmp_0 - divisor * Math.floor(x);
  return new (Number_0())(result);
}
function builtinFunctions$lambda_17(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var tmp0_elvis_lhs = numericArgs(args, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new (Error_0())('VALUE', 'POWER requires 2 numeric arguments');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nums = tmp;
  if (nums.get_size_woubt6_k$() < 2)
    return new (Error_0())('VALUE', 'POWER requires 2 arguments');
  var base = nums.get_c1px32_k$(0).value_1;
  var exp = nums.get_c1px32_k$(1).value_1;
  var tmp_0;
  if (base === 0.0 && exp === 0.0) {
    tmp_0 = new (Error_0())('NUM', '0^0 is undefined');
  } else {
    var tmp_1;
    if (base < 0.0) {
      // Inline function 'kotlin.math.floor' call
      tmp_1 = !(exp === Math.floor(exp));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = new (Error_0())('NUM', 'Negative base with fractional exponent');
    } else {
      // Inline function 'kotlin.math.pow' call
      var tmp$ret$1 = Math.pow(base, exp);
      tmp_0 = engineNumber(tmp$ret$1);
    }
  }
  return tmp_0;
}
function builtinFunctions$lambda_18(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  if (!(args.get_size_woubt6_k$() === 1))
    return new (Error_0())('VALUE', 'SQRT requires a number');
  var n = asNumber(args.get_c1px32_k$(0).eval_4bdj8k_k$(ctx));
  if (n instanceof Error_0())
    return n;
  var x = (n instanceof Number_0() ? n : THROW_CCE()).value_1;
  var tmp;
  if (x < 0.0) {
    tmp = new (Error_0())('NUM', 'Cannot take the square root of a negative number');
  } else {
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$0 = Math.sqrt(x);
    tmp = new (Number_0())(tmp$ret$0);
  }
  return tmp;
}
function builtinFunctions$lambda_19(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var vals = evalAll(args, ctx);
  var tmp0_safe_receiver = firstError(vals);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  return new (Text())(joinToString(vals, '', VOID, VOID, VOID, VOID, builtinFunctions$lambda$lambda_1));
}
function builtinFunctions$lambda$lambda_1(it) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return asText(it);
}
function builtinFunctions$lambda_20(args, ctx) {
  _init_properties_ExcelFunctions_kt__22brwc();
  var vals = evalAll(args, ctx);
  var tmp0_safe_receiver = firstError(vals);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  return new (Text())(joinToString(vals, '', VOID, VOID, VOID, VOID, builtinFunctions$lambda$lambda_2));
}
function builtinFunctions$lambda$lambda_2(it) {
  _init_properties_ExcelFunctions_kt__22brwc();
  return asText(it);
}
function RoundMode_NEAREST_getInstance() {
  static_init();
  return RoundMode_NEAREST_instance;
}
function RoundMode_UP_getInstance() {
  static_init();
  return RoundMode_UP_instance;
}
function RoundMode_DOWN_getInstance() {
  static_init();
  return RoundMode_DOWN_instance;
}
var properties_initialized_ExcelFunctions_kt_ebo97q;
function _init_properties_ExcelFunctions_kt__22brwc() {
  if (!properties_initialized_ExcelFunctions_kt_ebo97q) {
    properties_initialized_ExcelFunctions_kt_ebo97q = true;
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    var tmp = builtinFunctions$lambda;
    builtinFunctions$register(this_0, 'IF', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp));
    var tmp_0 = builtinFunctions$lambda_0;
    builtinFunctions$register(this_0, 'AND', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_0));
    var tmp_1 = builtinFunctions$lambda_1;
    builtinFunctions$register(this_0, 'OR', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_1));
    var tmp_2 = builtinFunctions$lambda_2;
    builtinFunctions$register(this_0, 'NOT', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_2));
    var tmp_3 = builtinFunctions$lambda_3;
    builtinFunctions$register(this_0, 'TRUE', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_3));
    var tmp_4 = builtinFunctions$lambda_4;
    builtinFunctions$register(this_0, 'FALSE', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_4));
    var tmp_5 = builtinFunctions$lambda_5;
    builtinFunctions$register(this_0, 'SWITCH', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_5));
    var tmp_6 = builtinFunctions$lambda_6;
    builtinFunctions$register(this_0, 'SUM', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_6));
    var tmp_7 = builtinFunctions$lambda_7;
    builtinFunctions$register(this_0, 'MAX', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_7));
    var tmp_8 = builtinFunctions$lambda_8;
    builtinFunctions$register(this_0, 'MIN', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_8));
    var tmp_9 = builtinFunctions$lambda_9;
    builtinFunctions$register(this_0, 'ABS', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_9));
    var tmp_10 = builtinFunctions$lambda_10;
    builtinFunctions$register(this_0, 'ROUND', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_10));
    var tmp_11 = builtinFunctions$lambda_11;
    builtinFunctions$register(this_0, 'ROUNDUP', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_11));
    var tmp_12 = builtinFunctions$lambda_12;
    builtinFunctions$register(this_0, 'ROUNDDOWN', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_12));
    var tmp_13 = builtinFunctions$lambda_13;
    builtinFunctions$register(this_0, 'FLOOR', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_13));
    var tmp_14 = builtinFunctions$lambda_14;
    builtinFunctions$register(this_0, 'CEILING', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_14));
    var tmp_15 = builtinFunctions$lambda_15;
    builtinFunctions$register(this_0, 'INT', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_15));
    var tmp_16 = builtinFunctions$lambda_16;
    builtinFunctions$register(this_0, 'MOD', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_16));
    var tmp_17 = builtinFunctions$lambda_17;
    builtinFunctions$register(this_0, 'POWER', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_17));
    var tmp_18 = builtinFunctions$lambda_18;
    builtinFunctions$register(this_0, 'SQRT', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_18));
    var tmp_19 = builtinFunctions$lambda_19;
    builtinFunctions$register(this_0, 'CONCAT', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_19));
    var tmp_20 = builtinFunctions$lambda_20;
    builtinFunctions$register(this_0, 'CONCATENATE', new (sam$org_thecommunitygroupinc_cares_excel_ExcelFunction$0())(tmp_20));
    builtinFunctions = this_0.build_nmwvly_k$();
  }
}
//region block: exports
export {
  get_builtinFunctions as get_builtinFunctions2kgzbz596qdv5,
};
//endregion

//# sourceMappingURL=ExcelFunctions.mjs.map
